/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { keepPreviousData } from '@tanstack/react-query';
import {
  fetchLayoutData,
  FetchLayoutDataParams,
  LayoutData,
} from '../services/contentService';
import { defaultHeaderData } from '../widgets/WebHeaderView/SampleData';
import { webFooterMock } from '../widgets/WebFooterView/types';

export const defaultLayoutData: LayoutData = {
  header: {
    navigationItems: defaultHeaderData,
  },
  footer: webFooterMock,
};

export const LAYOUT_QUERY_KEY = ['layout'];

export const createLayoutQueryOptions = (params: FetchLayoutDataParams) => {
  const locale = params.locale ?? 'en-gb';
  const slug = params.slug;
  const geoId = params.geoId;

  return {
    queryKey: [...LAYOUT_QUERY_KEY, params.env, locale, geoId, slug],
    queryFn: () => fetchLayoutData({ ...params, locale, geoId, slug }),
    placeholderData: keepPreviousData,
    staleTime: Infinity,
  };
};
